import { customCardTypesConfig } from '../constants';

import { getCardBrandTokenexName } from './getCardBrandTokenexName';

import type { TokenexBrand } from '../components/ui/CardBrandIcon';

/**
 * Detect the card brand from the given card number using regex patterns.
 * Returns the card brand as a string, or 'unknown' if not recognized.
 */
export const detectCardBrandFromNumber = (cardNumber: string): TokenexBrand => {
  const sanitizedNumber = cardNumber.replace(/\s+/g, '');

  // Check against valid regex patterns first, then "possible" regex patterns
  let cardConfig = customCardTypesConfig.find(confObj => {
    const validRegex = new RegExp(confObj.validRegex);
    return validRegex.test(sanitizedNumber);
  });

  if (!cardConfig) {
    cardConfig = customCardTypesConfig.find(confObj => {
      const validRegex = new RegExp(confObj.possibleRegEx);
      return validRegex.test(sanitizedNumber);
    });
  }

  return cardConfig ? getCardBrandTokenexName(cardConfig?.type) : 'unknown';
};
